import mockFFWBCW from "../../assets/images/mockupFFWBCW.png";
import mockGrace from "../../assets/images/mockupGrace.png";
import mockHereBoy from "../../assets/images/mockupHereBoy.png";

export interface Slide {
  cImg: string;
  cAlt: string;
}

export const CarouselContents: Slide[] = [
  {
    cImg: `${mockGrace}`,
    cAlt: "Project mockup from moreofgrace.org",
  },
  {
    cImg: `${mockHereBoy}`,
    cAlt: "Project mockup from https://hereboycodechallenge.netlify.app/",
  },
  {
    cImg: `${mockFFWBCW}`,
    cAlt: "Project mockup from ffwbcw.org",
  },
];
